/*
 * @Author: your name
 * @Date: 2020-11-23 17:04:09
 * @LastEditTime: 2020-11-25 21:45:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/store/index.js
 */

import { LOCAL_CONST_NAME } from '@/constant/index'
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
// 中间件
import localer from './middleware/localer'

import sysuserInfoSlice from './slice/sysuserInfo'
import tokenSlice from './slice/token'
import btmImgSlice from './slice/btmImg'

// 汇总reducer
const rootReducer = combineReducers({
	token: tokenSlice.reducer,
	sysuserInfo: sysuserInfoSlice.reducer,
	btmImg: btmImgSlice.reducer,
})

// 汇总中间件
const rootMiddleware = [localer];

// 是否开启devTools
const devTools = process.env.NODE_ENV !== 'production';
// 初始数据：必须是对象
const preloadedState = JSON.parse(localStorage.getItem(LOCAL_CONST_NAME))||{}


let store = configureStore({
	reducer:rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rootMiddleware),
	devTools,
	preloadedState
});
export { tokenSlice, sysuserInfoSlice,btmImgSlice }
export default store
